<template>
  <div class="ticket-create-new-ticket__container">
    <organism-ticket-create-new-ticket
      v-if="customerData"
      :customerData="customerData"
      :topicList="topicList"
      :ticketData="ticketData"
      @selectedTopicId="getTicketData"
      @createTicket="createTicketToApi"
    ></organism-ticket-create-new-ticket>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import {
  getExternalTopicList,
  getExternalTopicById,
  createNewExternalTicket,
  uploadExternalTicketAttachments,
  getExternalContractByIdcId,
} from "@/api/api-module1"
import mixins from "@/mixins"
import OrganismTicketCreateNewTicket from "@/components/organisms/portal/external/ticket/OrganismTicketCreateNewTicket.vue"
export default {
  components: { OrganismTicketCreateNewTicket },
  name: "ticketCreateNewTicket",
  mixins: [mixins],
  data() {
    return {
      // customer
      customerData: null,

      // ticket
      topicList: [],
      ticketData: null,
    }
  },
  computed: {
    isLoading() {
      return !this.customerData || this.topicList.length === 0
    },
    ...mapGetters("appPermission", ["getIdcId"]),

    idcId() {
      return this.getIdcId
    },
  },
  async created() {
    await this.getDataFromApi()
  },
  methods: {
    // get data from api
    async getDataFromApi() {
      await this.getTopicListFromApi()
      await this.getCustomerData()
    },

    async getCustomerData() {
      this.showLoading(true)
      await getExternalContractByIdcId(this.idcId)
        .then((contract) => {
          const emails = this.getUniqueArray(
            contract.contactPoints.map((c) => {
              if (c.contactType === "CUSTOMER") return c.contactEmail
            })
          )

          const phones = this.getUniqueArray(
            contract.contactPoints.map((c) => {
              if (c.contactType === "CUSTOMER") return c.contactPhone
            })
          )

          const contractLocation = contract.packages.map(
            (item) => item.locationName
          )

          this.customerData = {
            idcId: this.idcId.toString().padStart(8, "0"),
            name: contract.customer.customerName,
            email: emails.join(", "),
            phone: phones.join(", "),
            site: contract.siteName,
            locations: contractLocation.join("\n")
          }
        })
        .finally(() => this.showLoading(false))
    },

    // get topic list
    async getTopicListFromApi() {
      this.showLoading(true)
      this.topicList = []

      await getExternalTopicList()
        .then((topics) => {
          topics.forEach((topic) => {
            this.topicList.push({ id: topic.topicId, name: topic.topicName })
          })
        })
        .finally(() => this.showLoading(false))
    },

    // get ticket data
    async getTicketData(id) {
      this.showLoading(true)
      await getExternalTopicById(id)
        .then((topic) => {
          this.ticketData = {
            topic: this.topicList.find((t) => t.id === topic.topicId),
            subject: topic.topicSubject,
            detail: topic.topicDetail,
          }
        })
        .finally(() => this.showLoading(false))
    },

    // create ticket
    async createTicketToApi(createTicket, uploadAttachment) {
      this.showLoading(true)
      await createNewExternalTicket(createTicket)
        .then(async (ticket) => {
          if (ticket.status === "ok") {
            this.toastSuccess("Ticket created successfully")
            if (uploadAttachment) {
              await uploadExternalTicketAttachments(
                ticket.data.ticketId,
                uploadAttachment
              ).then((attachment) => {
                if (attachment.status === "ok")
                  this.toastSuccess("Attachment uploaded successfully")
                else this.toastError("Attachment uploaded failed")
              })
              .catch(() => {
                  this.toastError(
                    "Attachment uploaded failed. Please check the file size of your attachment and try again."
                  )
              })
            }

            this.$router.push(`/web-portal/ticket/${ticket.data.ticketId}`)
          } else this.toastError("Ticket created failed")
        })
        .finally(() => this.showLoading(false))
    },

    // get unique array
    getUniqueArray(array) {
      return array.filter(function (item, position, self) {
        return self.indexOf(item) === position
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.ticket-create-new-ticket__container {
  padding: 0 0 21px 0;
}
</style>
